import styled from 'styled-components';

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  background: var(--gray-line);
  padding: 40px;
  border-radius: 8px;
  max-width: 500px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: var(--purple);
  h1 {
    margin-bottom: 20px;
    font-size: 26px;
  }
  @media (max-width: 800px) {
    max-width: 300px;
  }
  .Conctact {
    margin-top: 20px;
    font-size: 16px;
    font-weight: bold;
    color: var(--orange);
  }
`;
